module.exports = __webpack_public_path__ + "static/media/vip_title_3.88900017.png";